import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskedLines, Reveal } from "@/components/Motion";
import ServiceGrid from "@/components/ServiceGrid";
import EditorialMarquee from "@/components/EditorialMarquee";
import { IMAGES } from "@/data/site";

const PROCESS = [
  { n: "01", t: "Request a quote", d: "Tell us about your space online or over the phone. It's fast and free." },
  { n: "02", t: "We confirm details", d: "We agree on scope, timing and a fixed, transparent price — no surprises." },
  { n: "03", t: "We make it sparkle", d: "Our insured, police-checked team arrives on time and delivers a spotless result." },
];

export default function Services() {
  return (
    <div>
      <section className="pt-40 pb-16 bg-[#FAFAF9]">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8">
          <p className="kicker mb-6">Our services</p>
          <h1 className="font-display font-extrabold tracking-tight text-[#1C2A39] text-5xl sm:text-7xl leading-[0.95]">
            <MaskedLines lines={["Every clean,", "covered."]} />
          </h1>
          <Reveal delay={0.5}><p className="mt-7 text-lg text-[#475569] max-w-xl">From weekly home cleans to bond-back guarantees and commercial contracts — one trusted Adelaide team for it all.</p></Reveal>
        </div>
      </section>

      <section className="pb-24 bg-[#FAFAF9]">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8"><ServiceGrid /></div>
      </section>

      <EditorialMarquee dark />

      {/* PROCESS */}
      <section className="py-24 sm:py-32 bg-white">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8">
          <div className="max-w-xl mb-16">
            <p className="kicker mb-4">How it works</p>
            <h2 className="font-display font-medium text-4xl sm:text-5xl tracking-tight text-[#1C2A39] leading-[1.05]">Booked in three easy steps.</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {PROCESS.map((p, i) => (
              <Reveal key={p.n} delay={i * 0.1}>
                <div className="bg-[#FAFAF9] rounded-3xl p-8 h-full border border-slate-200">
                  <span className="font-display font-light text-6xl text-[#0D9488]">{p.n}</span>
                  <h3 className="font-display font-medium text-2xl text-[#1C2A39] mt-5 mb-3">{p.t}</h3>
                  <p className="text-[#475569] leading-relaxed">{p.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-32 overflow-hidden">
        <img src={IMAGES.office} alt="Clean modern office" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#1C2A39]/70" />
        <div className="relative z-10 max-w-[1440px] mx-auto px-5 sm:px-8 text-center text-white">
          <h2 className="font-display font-medium text-4xl sm:text-6xl tracking-tight leading-[1.05] max-w-3xl mx-auto">Not sure which service you need?</h2>
          <p className="mt-6 text-slate-200 max-w-lg mx-auto">Tell us about your space and we'll recommend the right clean — with a free quote.</p>
          <Link to="/quote" className="btn-primary !bg-white !text-[#1C2A39] mt-8 hover:!bg-[#5EEAD4]">Get a Free Quote <ArrowRight size={18} /></Link>
        </div>
      </section>
    </div>
  );
}
